export const IDENTIDADE_API_URL = 'IDENTIDADE_API_URL';

export const AMBIENTE_PERMITIDO_AMBOS = 'Ambos';
export const AMBIENTE_PERMITIDO_TESTE = 'Teste';
export const AMBIENTE_PERMITIDO_PRODUCAO = 'Producao';
